<!-- Trip Distribution modal -->
<div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <!-- Background Overlay -->
    <div class="fixed inset-0 bg-[#363738] bg-opacity-25 backdrop-blur-sm transition-opacity dark:bg-[#3333331f]"></div>
    <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
            <div class="fixed inset-y-0 right-0 flex max-w-full pl-4 sm:pl-8">
                <div class="w-screen max-w-xl px-4 py-4">
                    <!-- Modal Content -->
                    <div class="flex h-full flex-col overflow-hidden rounded-lg border border-zinc-950/10 bg-white shadow-xl dark:border-white/10 dark:bg-zinc-950">
                        <div class="border-b border-zinc-200 px-4 py-2 dark:border-white/10">
                            <div class="flex items-center justify-between">
                                <h3 class="heading" id="slide-over-title">Reject Reason</h3>
                                <div class="ml-3 flex h-7 items-center space-x-4">
                                    <button (click)="onCloseModal()"
                                        class="rounded-md bg-white text-zinc-500 hover:text-zinc-700 focus:ring-2 focus:ring-primary dark:bg-white/5 dark:text-white dark:hover:text-zinc-300"
                                        type="button">
                                        <span class="sr-only">Close panel</span>
                                        <svg aria-hidden="true" class="h-6 w-6" fill="none" stroke="currentColor"
                                            stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round"
                                                stroke-linejoin="round"></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-1 flex-col items-start gap-4 overflow-hidden p-4 lg:flex-row">
                            <div class="flex-1 flex flex-col overflow-y-auto">
                                <ul role="list" class="">
                                    <form [formGroup]="reasonForm" class="space-y-6">
                                        <div>
                                            <!-- <label for="other-reason"
                                                class="block text-sm font-medium text-main-secondary">
                                                Reject Reason
                                            </label> -->
                                            <div class="mt-1">
                                                <textarea formControlName="rejectReason" rows="4" name="other-reason"
                                                    class="resize-none form-control ng-pristine ng-untouched ng-valid ng-empty"
                                                    id="example-textarea"></textarea>
                                            </div>
                                            <div *ngIf="submitted && form.rejectReason.errors">
                                                <p *ngIf="form.rejectReason.errors.required" class="pt-1 text-red-600 text-xs">
                                                    Reject reason is required
                                                </p>
                                            </div>
                                            <!-- <p *ngIf="!rejectReason || rejectReason === ''"
                                                class="mt-4 text-xs text-red-600">
                                                Kindly select the reason for cancellation.
                                            </p> -->
                                        </div>
                                    </form>
                                </ul>
                            </div>
                        </div>
                        <div class="border-t border-zinc-200 px-4 py-2 dark:border-white/10">
                            <div class="flex items-center justify-end gap-2">
                                <!-- [disabled]="!cancelReason || cancelReason === ''" -->
                                <button type="button" class="btn btn-danger" (click)="onSave()"
                                    data-dismiss="modal">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>